module.exports = __webpack_public_path__ + "static/media/1009964.d0cb6441.jpg";